import { render, staticRenderFns } from "./left-fourSelectOne.vue?vue&type=template&id=2cc49e1c&scoped=true"
import script from "./left-fourSelectOne.vue?vue&type=script&lang=js"
export * from "./left-fourSelectOne.vue?vue&type=script&lang=js"
import style0 from "./left-fourSelectOne.vue?vue&type=style&index=0&id=2cc49e1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc49e1c",
  null
  
)

export default component.exports